import { AmplifyService } from './amplify.service';
export default (function (modules) {
    return new AmplifyService(modules);
});
//# sourceMappingURL=amplify.compose.service.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-amplify-angular/dist/src/providers/amplify.compose.service.js
// module id = null
// module chunks = 